import { Text } from 'ui'
import Button from 'ui/Button'
import { Div } from 'ui'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import ModalTemplate from '../components/ModalTemplate'
import { ReactComponent as FlixxSVG } from 'assets/icons/flixx.svg'
import useModal from 'hooks/useModal'

const Background = styled.div`
  width: 70%;
  height: 50%;
  position: absolute;
  top: 50px;
  left: 50%;
  background-color: ${({ theme }) => theme.colors.basics.brand};
  opacity: 0.4;
  filter: blur(100px);
  transform: translateX(-50%) translate3d(0, 0, 0); // hack needed to blur works fine in iOS/safari
`

const ModalStyled = styled(ModalTemplate)`
  min-height: 536px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const Onboarding = () => {

  const { t } = useTranslation()
  const theme = useTheme()
  const { Modal } = useModal()

  return (
    <ModalStyled customBackground={Background}>
      <Div
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        flexGrow={1}
        paddingBottom={10}
      >
        <div>
          <Div
            width={72}
            height={72}
            backgroundColor={theme.colors.neutral[400]}
            borderRadius={100}
            display='grid'
            placeItems='center'
            margin='0 auto'
          >
            <FlixxSVG height={27} width={18} />
          </Div>

          <Div marginTop={24} marginBottom={16}>
            <Text align='center' color='headline' size='xl'>
              {t('flixxoIsFree')}
            </Text>
          </Div>

          <Div
            as='ul'
            marginLeft={30}
            display='flex'
            flexDirection='column'
            gap={16}
          >
            <Text as='li'>
              {t('contentPricedInFlixx')}
              {' '}
              <span style={{ display: 'inline-block' }}>
                (<FlixxSVG
                  width={8}
                  height={12}
                  color={theme.text.headline}
                />)
              </span>
            </Text>

            <Text as='li'>
              {t('ifDontOwnFlixxWillPlayAd')}
            </Text>

            <Text as='li'>
              {t('earnFlixxInChallengesSection')}
            </Text>
          </Div>
        </div>

        <Button isFull size='large' onClick={Modal.close}>
          {t('great')}
        </Button>
      </Div>
    </ModalStyled>
  )
}

export default Onboarding